import gql from 'graphql-tag';

export const virtualPabxQueueStatisticsFragment = gql`
  fragment virtualPabxQueueStatisticsParts on VirtualPabxQueueStatistics {
    totalCalls
    answeredCalls
    abandonedCalls
    timedoutCalls
    tme
    tma
    tmc
    tmab
    callerHangupCalls
    queueMemberHangupCalls
    slaAnsweredCalls
  }
`;

export const virtualPabxAgentPauseReasonFragment = gql`
  fragment virtualPabxAgentPauseReasonParts on VirtualPabxAgentPauseReason {
    reason
    totalSeconds
    count
  }
`;

export const virtualPabxAgentStatisticsEventFragment = gql`
  fragment virtualPabxAgentStatisticsEventParts on VirtualPabxAgentStatisticsEvent {
    date
    eventType
    queueName
  }
`;

export const virtualPabxAgentStatisticsFragment = gql`
  fragment virtualPabxAgentStatisticsParts on VirtualPabxAgentStatistics {
    totalCalls
    answeredCalls
    unansweredCalls
    tme
    tma
    tmc
    pausesByReason {
      ...virtualPabxAgentPauseReasonParts
    }
    events {
      ...virtualPabxAgentStatisticsEventParts
    }
  }
  ${virtualPabxAgentPauseReasonFragment}
  ${virtualPabxAgentStatisticsEventFragment}
`;
